var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-panel"},[_c('bg-option'),_c('div',{staticClass:"map-panel"},[_c('maps',{ref:"map",attrs:{"detail":"","store-info":_vm.storeInfo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }